import * as React from 'react'
import { connect } from 'react-redux'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Container } from '@amzn/dvui/dist/Container'
import { Link } from '@amzn/dvui/dist/Link'
import { Text } from '@amzn/dvui/dist/Text'
import * as st from './scoutBanner.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { IDetailPageState } from '../../reducers'
import { showScoutBannerSelector } from '../../selectors/scoutBanner'
import { pageSelectors } from '../../selectors/basicState'

export interface IScoutBannerProps {
  showScoutBanner: boolean
  scout?: WpsRuntime.atv.wps.ScoutBannerModelProps,
}

export const ConnectedScoutBanner = ({ scout, showScoutBanner }: IScoutBannerProps) =>
  showScoutBanner ? (
    <Container className={`${stUtility.pageSection} ${st.scoutBanner}`}>
      <h1 className={st.scoutBannerDiscover}><Text string={scout.discover} /></h1>
      <Link href={scout.pageLink}>
        <div className={st.scoutBannerBody} >
          <div className={st.scoutBannerBodyContents} >
            <h2><strong><Text string={scout.newBadge} /></strong><Text string={scout.header} /></h2>
            <div>
              <Text string={scout.body} className={st.scoutBannerBodyText} />
              <Text string={scout.tryNow} className={st.scoutTryNow} />
            </div>
          </div>
        </div>
      </Link>
    </Container>) : null

const mapStateToProps = (state: IDetailPageState): IScoutBannerProps => ({
  scout: pageSelectors.scoutBanner(state),
  showScoutBanner: showScoutBannerSelector(state)
})

export const ScoutBanner = connect(mapStateToProps)(
  ConnectedScoutBanner
)
